import { acoesRealizadasMap } from "@enums/SolicitacaoHistorico/AcaoRealizada/Index";

const AcaoRealizadaComp = ({ acaoRealizada }) => {
    return <span>{acoesRealizadasMap[acaoRealizada]}</span>;
};

export default AcaoRealizadaComp;
